import { Phone } from 'lucide-react';
import { Link } from 'react-router-dom';
import { FadeUp } from './motion';
import { PHONE_TEL, PHONE_DISPLAY } from '../data/content';

export const CTASection = () => (
  <section data-testid="cta-section" className="relative py-24 md:py-32 overflow-hidden">
    <div className="absolute inset-0 bg-[#0A1128]" />
    <div
      className="absolute -right-40 top-1/2 -translate-y-1/2 font-display font-semibold text-[26vw] leading-none text-stroke select-none pointer-events-none"
      aria-hidden
    >
      VİRA
    </div>
    <div className="relative max-w-7xl mx-auto px-6 md:px-10">
      <FadeUp>
        <p className="text-xs uppercase tracking-[0.3em] text-[#FF5C00] mb-6">
          Taşınmaya hazır mısınız?
        </p>
        <h2 className="font-display font-medium tracking-tighter leading-none text-4xl sm:text-5xl lg:text-7xl max-w-3xl mb-10">
          Yeni yuvanıza bir telefon{' '}
          <span className="text-[#FF5C00]">uzaktasınız.</span>
        </h2>
        <div className="flex flex-wrap items-center gap-5">
          <a
            href={PHONE_TEL}
            data-testid="cta-call-button"
            className="group inline-flex items-center gap-3 bg-[#FF5C00] hover:bg-[#E65000] text-[#0A1128] font-bold text-base md:text-lg rounded-full pl-7 pr-8 py-4 transition-colors duration-300"
          >
            <Phone size={20} strokeWidth={2.5} className="transition-transform duration-500 group-hover:rotate-12" />
            {PHONE_DISPLAY}
          </a>
          <Link
            to="/hizmetler"
            data-testid="cta-services-link"
            className="inline-flex items-center gap-2 border border-[#1E293B] hover:border-[#FF5C00] text-[#F2F4F8] rounded-full px-7 py-4 text-base transition-colors duration-300"
          >
            Hizmetleri İncele
          </Link>
        </div>
      </FadeUp>
    </div>
  </section>
);
